import { render, staticRenderFns } from "./MaterialVariantHistory.vue?vue&type=template&id=0bf7c608&scoped=true"
import script from "./MaterialVariantHistory.vue?vue&type=script&lang=js"
export * from "./MaterialVariantHistory.vue?vue&type=script&lang=js"
import style0 from "./MaterialVariantHistory.vue?vue&type=style&index=0&id=0bf7c608&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf7c608",
  null
  
)

export default component.exports